<template>
  <div id="generate-document">
    <GlobalLoading v-if="isLoading" />
    <div class="document-container">
      <div ref="document" class="document-wrapper">
        <div class="doc-title-underline">SURAT PERNYATAAN NON PKP</div>
        <div class="pdf-text mt40">Yang bertanda tangan dibawah ini</div>
        <div class="pdf-form-wrapper mt20">
          <div class="pdf-form doc-indent">
            <span>Nama</span>
            <span>: </span>
          </div>
          <div class="pdf-form-content">{{ $route.query.nama }}</div>
        </div>
        <div class="pdf-form-wrapper mt20">
          <div class="pdf-form doc-indent">
            <span>Jabatan</span>
            <span>: </span>
          </div>
          <div class="pdf-form-content">{{ $route.query.jabatan }}</div>
        </div>
        <div class="pdf-form-wrapper mt20">
          <div class="pdf-form doc-indent">
            <span>Perusahaan</span>
            <span>: </span>
          </div>
          <div class="pdf-form-content">{{ $route.query.perusahaan }}</div>
        </div>
        <div class="pdf-form-wrapper mt20">
          <div class="pdf-form doc-indent">
            <span>Alamat</span>
            <span>: </span>
          </div>
          <div class="pdf-form-content">{{ $route.query.alamat }}</div>
        </div>

        <div class="pdf-text mt20">
          Dengan ini menyatakan bahwa kami adalah bukan Perusahaan Kena Pajak
          sebagaimana dimaksud pada Undang-Undang Pajak Pertambahan Nilai. Oleh
          karenanya terhadap penjualan penyerahan Barang Kena Pajak atau Jasa
          Kena Pajak yang kami lakukan ke Perusahaan Bapak Ibu, kami tidak dapat
          menerbitkan Faktur Pajak.
        </div>
        <div class="pdf-text mt20">
          Demikian Surat Pernyataan ini saya buat dengan sebenarnya dan agar
          dapat digunakan sebagai mestinya.
        </div>
        <div class="pdf-sign-right-wrapper mt40">
          <div class="pdf-sign text-center">
            <div class="pdf-text">
              ...............................,{{ formatDate(Date.now()) }}
            </div>
            <div class="pdf-text mt10">Pemberi Pernyataan</div>
            <div class="devider20"></div>
            <div class="pdf-text mt20">
              ({{ $get($route, 'query.nama', '....................') }})
            </div>
          </div>
        </div>
      </div>
    </div>

    <button class="floating-button" @click="exportToPDF">Export to PDF</button>
    <button class="top-floating-button" @click="exportToPDF">
      Export to PDF
    </button>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default {
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
    }
  },
  methods: {
    async exportToPDF() {
      this.isVisible = true
      this.isLoading = true
      html2pdf(this.$refs.document, {
        margin: 1,
        filename: 'Surat Pernyataan Non PKP.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 4, dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      })
      this.isVisible = false
      this.isLoading = false
    },
  },
}
</script>
